/* eslint-disable no-loss-of-precision */

export const containersReference = [
    {
        id: 'container_1',
        name: 'GreenFrame Browser',
        score: {
            wh: {
                cpu: 0.005671875,
                mem: 0.00013629391056888888,
                disk: 2.5526272e-7,
                total: 0.04504212117328888,
                screen: 0.036775,
                network: 0.0094633845,
            },
            co2: {
                total: 0.02016617558593688,
            },
        },
        stats: [
            {
                n: 2,
                io: {
                    totalBytes: 0,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 0,
                    totalUsageInUserMode: 0,
                    currentUsageInUserMode: 0,
                    totalUsageInKernelMode: 0,
                    availableSystemCpuUsage: 0,
                    currentUsageInKernelMode: 0,
                },
                date: '2022-01-17T09:09:12.766Z',
                time: 1.0145,
                active: false,
                memory: {
                    usage: 0,
                },
                network: {
                    totalReceived: 0,
                    currentReceived: 0,
                    totalTransmitted: 0,
                    currentTransmitted: 0,
                },
                userTime: 0,
            },
            {
                n: 2,
                io: {
                    totalBytes: 0,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 0,
                    totalUsageInUserMode: 0,
                    currentUsageInUserMode: 0,
                    totalUsageInKernelMode: 0,
                    availableSystemCpuUsage: 0,
                    currentUsageInKernelMode: 0,
                },
                date: '2022-01-17T09:09:13.781Z',
                time: 2.0244999999999997,
                active: false,
                memory: {
                    usage: 0,
                },
                network: {
                    totalReceived: 0,
                    currentReceived: 0,
                    totalTransmitted: 0,
                    currentTransmitted: 0,
                },
                userTime: 0,
            },
            {
                n: 2,
                io: {
                    totalBytes: 0,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 4.428044280442803,
                    totalUsageInUserMode: 0.045,
                    currentUsageInUserMode: 0.044687189672293945,
                    totalUsageInKernelMode: 0.00875,
                    availableSystemCpuUsage: 0.5045928500496526,
                    currentUsageInKernelMode: 0.008689175769612712,
                },
                date: '2022-01-17T09:09:14.795Z',
                time: 3.0349999999999997,
                active: true,
                memory: {
                    usage: 178442240,
                },
                network: {
                    totalReceived: 549008.5,
                    currentReceived: 175192.1549155909,
                    totalTransmitted: 12932.5,
                    currentTransmitted: 12842.601787487589,
                },
                userTime: 0.4755,
                timeframe: {
                    end: '2022-01-17T09:09:35.291Z',
                    start: '2022-01-17T09:09:29.009Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 0,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 2.2167487684729066,
                    totalUsageInUserMode: 0.0675,
                    currentUsageInUserMode: 0.022189349112426034,
                    totalUsageInKernelMode: 0.011875,
                    availableSystemCpuUsage: 0.5004930966469427,
                    currentUsageInKernelMode: 0.003081854043392505,
                },
                date: '2022-01-17T09:09:15.804Z',
                time: 4.0465,
                active: true,
                memory: {
                    usage: 189247488,
                },
                network: {
                    totalReceived: 549008.5,
                    currentReceived: 265192.1549155909,
                    totalTransmitted: 12932.5,
                    currentTransmitted: 12842.601787487589,
                },
                userTime: 0.9824999999999999,
                timeframe: {
                    end: '2022-01-17T09:09:35.291Z',
                    start: '2022-01-17T09:09:29.009Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 17.20607990447286,
                    totalUsageInUserMode: 0.54,
                    currentUsageInUserMode: 0.17681274900398408,
                    totalUsageInKernelMode: 0.135,
                    availableSystemCpuUsage: 0.9985059760956175,
                    currentUsageInKernelMode: 0.0348605577689243,
                },
                date: '2022-01-19T14:25:44.327Z',
                time: 5.0195,
                active: true,
                memory: {
                    usage: 168421376,
                },
                network: {
                    totalReceived: 1372257.5,
                    currentReceived: 176058.76494023902,
                    totalTransmitted: 44808,
                    currentTransmitted: 7445.11952191235,
                },
                userTime: 2.4325,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 12.20995176440721,
                    totalUsageInUserMode: 0.66,
                    currentUsageInUserMode: 0.13064107676969093,
                    totalUsageInKernelMode: 0.1525,
                    availableSystemCpuUsage: 0.9895314057826521,
                    currentUsageInKernelMode: 0.017447657028913263,
                },
                date: '2022-01-19T14:25:45.330Z',
                time: 6.0225,
                active: true,
                memory: {
                    usage: 177692672,
                },
                network: {
                    totalReceived: 1491495.5,
                    currentReceived: 111881.3559322034,
                    totalTransmitted: 50500.5,
                    currentTransmitted: 5475.473579262214,
                },
                userTime: 3.4354999999999998,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 24.23606573855355,
                    totalUsageInUserMode: 0.9025,
                    currentUsageInUserMode: 0.14153386454183268,
                    totalUsageInKernelMode: 0.20500000000000002,
                    availableSystemCpuUsage: 0.9935258964143426,
                    currentUsageInKernelMode: 0.05229083665338645,
                },
                date: '2022-01-19T14:25:46.334Z',
                time: 7.0264999999999995,
                active: true,
                memory: {
                    usage: 203620352,
                },
                network: {
                    totalReceived: 1574396,
                    currentReceived: 82570.21912350597,
                    totalTransmitted: 68145,
                    currentTransmitted: 10574.203187250998,
                },
                userTime: 4.4395,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 12.222884077488864,
                    totalUsageInUserMode: 1.3225,
                    currentUsageInUserMode: 0.16944510515153318,
                    totalUsageInKernelMode: 0.225,
                    availableSystemCpuUsage: 0.9781000376603042,
                    currentUsageInKernelMode: 0.019907930467185985,
                },
                date: '2022-01-19T14:25:47.339Z',
                time: 8.030999999999999,
                active: true,
                memory: {
                    usage: 209094656,
                },
                network: {
                    totalReceived: 1847419,
                    currentReceived: 141813.74155120814,
                    totalTransmitted: 79770,
                    currentTransmitted: 15571.89649362748,
                },
                userTime: 5.443999999999999,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 23.357223782079704,
                    totalUsageInUserMode: 1.2574999999999998,
                    currentUsageInUserMode: 0.20280517888879698,
                    totalUsageInKernelMode: 0.2725,
                    availableSystemCpuUsage: 1.0000206887583198,
                    currentUsageInKernelMode: 0.04701766622924722,
                },
                date: '2022-01-19T14:25:48.350Z',
                time: 9.038499999999999,
                active: true,
                memory: {
                    usage: 222150656,
                },
                network: {
                    totalReceived: 1980644.5,
                    currentReceived: 111820.75555345387,
                    totalTransmitted: 101388,
                    currentTransmitted: 19405.27110154831,
                },
                userTime: 6.451499999999999,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 14.185138892431702,
                    totalUsageInUserMode: 1.3875,
                    currentUsageInUserMode: 0.13952669355118727,
                    totalUsageInKernelMode: 0.2975,
                    availableSystemCpuUsage: 0.9860517948641638,
                    currentUsageInKernelMode: 0.024915303839724613,
                },
                date: '2022-01-19T14:25:49.355Z',
                time: 10.042499999999999,
                active: true,
                memory: {
                    usage: 227553280,
                },
                network: {
                    totalReceived: 2086465.5,
                    currentReceived: 125313.7254901961,
                    totalTransmitted: 108605,
                    currentTransmitted: 6189.909872372932,
                },
                userTime: 7.455499999999999,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
        ],
    },
    {
        id: 'container_2',
        name: 'Acme API',
        score: {
            co2: {
                total: 0.00784,
            },
        },
    },
    {
        id: 'container_3',
        name: 'Acme Database',
        score: {
            co2: {
                total: 0.001916617558593688,
            },
        },
    },
];
